import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { AppConfigurationService } from '../../base/appConfiguration.service';
@Injectable({
  providedIn: 'root',
})
export class PropostaCotacaoService {
  constructor(
    private httpClient: HttpClient,
    private appConfigurationService: AppConfigurationService,
  ) {}

  cadastrar(data: any, isBeneficiary: boolean): Observable<any> {
    return this.httpClient
      .post<any>(
        `${this.appConfigurationService.apiBaseUrl}/Proposal/FullProposal?isBeneficiary=${isBeneficiary}`,
        data,
      )
      .pipe(
        map(response => {
          return response;
        }),

        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  atualizar(propostaVM: any): Observable<any> {
    return this.httpClient
      .put<any>(`${this.appConfigurationService.apiBaseUrl}/Proposal/FullProposal`, propostaVM)
      .pipe(
        map(response => {
          return response;
        }),

        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  listarTodos(
    page?: any,
    itemsPerPage?: any,
    formFiltro?: any,
    responsibleId?: any,
    contractType?: any,
    vendorId?: any,
    productId?: any,
    status?: any,
  ): Observable<any> {
    //url padrao quando nao esta sendo filtrado os dado
    let url = `${this.appConfigurationService.apiBaseUrl}/Proposal/Search`;
    if (!isNaN(page) && !isNaN(itemsPerPage)) {
      url += `?skip=${page}&take=${itemsPerPage}`;
    }

    if (responsibleId != null && responsibleId != undefined) url += `&responsibleId=${responsibleId}`;

    if (contractType) {
      url += `&contractType=${contractType}`;
    }
    if (productId) {
      url += `&productId=${productId}`;
    }

    if (vendorId) {
      url += `&vendorId=${vendorId}`;
    }

    // Para array de status
    // if (status && Array.isArray(status)) {
    //   // Junta todos em uma string separada por &
    //   const statusParams = status.map(s => `stepsEnum=${s}`).join('&');
    //   url += `&${statusParams}`;
    // } else if (status) {
    //   url += `&stepsEnum=${status}`;
    // }
    const body: any = {};
    if (status) {
      let stepsEnum = status;
      if (Array.isArray(status) && status.length > 0 && Array.isArray(status[0])) {
        stepsEnum = status.flat();
      }
      body.stepsEnum = stepsEnum;
    }

    if (vendorId && Array.isArray(vendorId) && vendorId.length > 0) {
      body.brokerEmployeeIds = vendorId;
    }

    if (formFiltro) url += `&searchField=${formFiltro}`;
    return this.httpClient.post<any>(url, body).pipe(
      map(response => response),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  buscarDadosPropostaPorId(id: string | undefined): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/Proposal/FullProposal/${id}`).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  dadosEnderecoPorProposta(idProposta: string | undefined): Observable<any> {
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/Proposal/${idProposta}/AddressData/`)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }
  // O valor default 'false' garante que, se não for passado, ele assuma false.
  cadastrarEndereco(enderecoVM: any, ehColaborador: boolean = false): Observable<any> {
    let url = `${this.appConfigurationService.apiBaseUrl}/Proposal/${enderecoVM.proposalId}/AddressData`;

    // Adiciona o query param apenas se for explicitamente true
    if (ehColaborador === true) {
      url += `?isColaborator=${ehColaborador}`;
    }

    return this.httpClient.post<any>(url, enderecoVM).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  enviarEmailConfirmacao(idProposta: string) {
    return this.httpClient
      .post<any>(`${this.appConfigurationService.apiBaseUrl}/Proposal/${idProposta}/SendConfirmationEmail`, {})
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  salvarDocumentosReducaoCarencia(formData: FormData, url: string): Observable<Number> {
    return this.httpClient.post<Number>(url, formData).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  buscarGrauParentesco(idEntidade: any): Observable<any> {
    return this.httpClient
      .get<any>(
        `${this.appConfigurationService.apiBaseUrl}/AllLists/ListRelationshipsByBranchCompanyContract?BranchCompanyContractId=${idEntidade}`,
      )
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  finalizarProposta(proposalId: string, dados: any): Observable<any> {
    return this.httpClient
      .put(`${this.appConfigurationService.apiBaseUrl}/Proposal/FinishProposal?proposalId=${proposalId}`, dados)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  buscarBeneficiariosAguardandoPortabilidade(proposalId: string): Observable<any> {
    return this.httpClient
      .get(`${this.appConfigurationService.apiBaseUrl}/Proposal/BeneficiariesPortability?proposalId=${proposalId}`)
      .pipe(
        map(response => response),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  enviarBeneficiariosPortabilidade(proposalId: string, dados: any): Observable<any> {
    return this.httpClient
      .put(
        `${this.appConfigurationService.apiBaseUrl}/Proposal/ReturnOperatorPortability?proposalId=${proposalId}`,
        dados,
      )
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
            error: err.error,
          }));
        }),
      );
  }

  buscarDadosDocumentoFinal(idProposta: string, listaIdsBeneficiarios: string[]): Observable<any> {
    let params = new HttpParams();

    if (listaIdsBeneficiarios && listaIdsBeneficiarios.length > 0) {
      listaIdsBeneficiarios.forEach(id => {
        params = params.append('BeneficiariesHealthQuestion', id);
      });
    }

    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/Proposal/FullProposalToProposalDocument/${idProposta}`, {
        params,
      })
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  assinarModaisAditivos(data: any): Observable<any> {
    return this.httpClient
      .post<any>(`${this.appConfigurationService.apiBaseUrl}/Proposal/AdditiveSignature`, data)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  enviarRetornoOperadorSumula21(proposalId: string, vidas: any[]): Observable<any> {
    return this.httpClient
      .put(`${this.appConfigurationService.apiBaseUrl}/Proposal/ReturnOperatorSumula21?proposalId=${proposalId}`, vidas)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }
}
